import child from '../../../../general/child';

import * as exElement from '../../../element';

import type { IUploadItemTextConfig } from '../types';

import setUploadItemText from './setUploadItemText';

// ----------------------------------------------------------------------------

function createUploadItemText(
    config: IUploadItemTextConfig | undefined,
    className: string,
    value: string,
): HTMLElement | undefined {
    if (config?.enabled === false) {
        return undefined;
    }

    const element = exElement.create({
        class: {
            new: className,
        },
    });

    const custom = config?.custom;

    // Static markup is rendered once here; a render function goes through the value path.
    if (custom !== undefined && typeof custom !== 'function') {
        /*
         * An element is cloned rather than appended: one config object is shared by every item of
         * a batch, so appending the node itself would move it from one item to the next and leave
         * all but the last with an empty span.
         */
        child(element, custom instanceof HTMLElement ? (custom.cloneNode(true) as HTMLElement) : custom);
    } else {
        setUploadItemText(element, value, custom);
    }

    return element;
}

// ----------------------------------------------------------------------------

export default createUploadItemText;
